<template>
  <div class="questionnaire-view-form">
    <div class="common-parse-session-card">
      <div class="card-title">{{ customContent.title }}</div>
      <el-divider></el-divider>
      <div class="card-body">
        <div class="form-list">
          <el-form :ref="customContent.formConfig.refName" :model="formData" label-position="top" :label-width="customContent.formConfig.labelWidth + 'px'">
            <el-form-item :label="getLabelText(form)" v-for="(form, index) in customContent.formList" :key="index">
              <el-radio-group v-if="form.type === 'radio'" v-model="formData[form.options.name]">
                <el-radio :label="item.label" :value="item.value" v-for="(item, itemIndex) in form.options.optionItems" :key="itemIndex"></el-radio>
              </el-radio-group>
              <el-button v-else-if="form.type === 'button'" type="primary" :size="form.options.size" @click="formDataSub(form.options.action)">{{ form.textContent }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionnaireViewForm',
  props: {
    customContent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      formData: {}
    }
  },
  methods: {
    getLabelText (form) {
      return form.type === 'button' ? '' : form.textContent
    },
    formDataSub (action) {
      console.log(Object.keys(this.formData).length)
      if (Object.keys(this.formData).length === 0) {
        this.$message.error('未选择任何选项')
      } else {
        this.$message.success('已选择：' + JSON.stringify(this.formData))
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.questionnaire-view-form {
  padding: 5px 16px;
  white-space: normal;
}
.card-body {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999;
}
.form-list {
  padding-top: 10px;
}
.el-divider--horizontal {
  margin: 0;
}
.card-body >>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
.card-body >>> .el-form-item__label {
  line-height: 20px;
}
.el-radio {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/QuestionnaireViewForm.vue